import {css} from '@emotion/react';
import {useTheme} from '@mui/material';
import {ConfigObjectType, GetStylesFunction, useApiQuery, ApplicationInfo} from '@wallaby-ui/core';
import * as React from 'react';

import {NavigationExportProcessingInfo} from './NavigationExportProcessingInfo';
import {WallabyCoreSchema} from '@wallaby-ui/document';

interface OwnProps {
  config: ConfigObjectType;
  isNavigationOpen: boolean;
}

type Props = OwnProps;

export const NavigationExportProcessingInfoContainer: React.FC<Props> = (props) => {
  const {config, isNavigationOpen} = props;

  const theme = useTheme();
  const styles = getStyles({theme});

  const apiUrl = config.service.url.processingStatus;
  const appName = ApplicationInfo.getAppName();
  const apiParams = {
    application: appName,
  };
  const {data} = useApiQuery<WallabyCoreSchema.components['schemas']['ApplicationProcessingStatusDto']>([apiUrl, appName], null, {
    axiosConfig: {
      url: apiUrl,
      params: new URLSearchParams(apiParams),
    },
    reactQueryOptions: {
      enabled: true,
      refetchInterval: 300_000,
    },
  });

  return (
    <div css={styles.container}>
      {/* Green icon — last successful processing date. Always rendered (LOADING/PROCESSING/FINISHED). */}
      <NavigationExportProcessingInfo date={data?.processedAt} dateType='lastProcessing' isNavigationOpen={isNavigationOpen} />

      <div style={{paddingTop: '7px'}}>
        {/* Orange icon — LOADING: shows "Nahrávám data" label, no date.
          PROCESSING: shows source-export time (or '-' when missing). FINISHED: hidden. */}
        {data?.status === 'LOADING' && <NavigationExportProcessingInfo dateType='loading' isNavigationOpen={isNavigationOpen} />}
        {data?.status === 'PROCESSING' && (
          <NavigationExportProcessingInfo date={data?.sourceExportedAt} dateType='currentProcessing' isNavigationOpen={isNavigationOpen} />
        )}
      </div>
    </div>
  );
};

NavigationExportProcessingInfoContainer.displayName = 'NavigationExportProcessingInfoContainer';

const getStyles: GetStylesFunction = (options) => {
  return {
    container: css({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      paddingTop: options?.theme?.spacing(2),
      paddingBottom: options?.theme?.spacing(2),
    }),
  };
};
